"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrdersSubmit = void 0;
const confirmation_modal_1 = require("client/components/confirmation-modal");
const kpi_header_1 = require("client/components/kpi-header");
const kpi_element_1 = require("client/components/kpi-header/kpi-element");
const kpi_element_group_1 = require("client/components/kpi-header/kpi-element-group");
const kpi_title_1 = require("client/components/kpi-header/kpi-title");
const button_1 = require("client/components/material/button");
const checkbox_1 = require("client/components/material/checkbox/checkbox");
const paper_1 = require("client/components/material/paper");
const select_1 = require("client/components/material/select");
const toolbar_1 = require("client/components/material/toolbar");
const router_1 = require("client/components/router"); // #TK added to redirect import for header row selection
const ui_1 = require("client/components/ui");
const alert_1 = require("client/components/ui/alert");
const loading_indicator_1 = require("client/components/ui/loading-indicator");
const store_1 = require("client/modules/orders/store");
const edit_patient_1 = require("client/modules/patients/modules/patients-detail/components/edit-patient");
const store_2 = require("client/modules/patients/store");
const edit_provider_1 = require("client/modules/providers/modules/providers-list/components/edit-provider");
const store_3 = require("client/modules/providers/store");
const store_4 = require("client/modules/sites/modules/sites-detail/store");
const store_5 = require("client/modules/sites/modules/sites-list/store");
const store_6 = require("client/modules/users/store");
const Backup_1 = require("material-ui-icons/Backup");
const CheckCircle_1 = require("material-ui-icons/CheckCircle");
const Launch_1 = require("material-ui-icons/Launch");
const Warning_1 = require("material-ui-icons/Warning");
const Table_1 = require("material-ui/Table");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const moment = require("moment");
const ramda_1 = require("ramda");
const React = require("react");
const react_1 = require("react");
const ReactTooltip = require("react-tooltip");
const order_1 = require("shared/order");
const util_1 = require("shared/util");
require("./orders-submit.less");
const greenElement = {
    color: kpi_element_1.KPIElementColor.Green,
    label: "Ready to Transmit",
    size: kpi_element_1.KPIElementSize.Small,
    value: 0
};
const redElement = {
    color: kpi_element_1.KPIElementColor.Red,
    label: "Action Required",
    size: kpi_element_1.KPIElementSize.Large,
    value: 0
};
const yellowElement = {
    color: kpi_element_1.KPIElementColor.Yellow,
    label: "Already Submitted",
    size: kpi_element_1.KPIElementSize.Small,
    value: 0
};
let OrdersSubmit = class OrdersSubmit extends react_1.Component {
    constructor(props) {
        super(props);
        this.checkedBoxes = {};
        this.checkedAll = false;
        this.indeterminate = false;
        this.numChecked = 0;
        this.editRowIndex = -1;
        this.cacheRowIndex = -1;
        this.currentRowIndex = -1;
        this.patient = {};
        this.provider = {};
        this.siteId = store_6.usersStore.user.value && store_6.usersStore.user.value.siteId
            ? store_6.usersStore.user.value.siteId.toString()
            : "";
        this.siteSelected = false;
        this.imageFiles = [];
        this.cancelButtonClicked = false;
        this.selectedSiteId = null;
        this.providerId = null;
        this.loadingSaving = false;
        this.isPICExpired = false; // C-095
        this.tkAccepted = [];
        this.siteAndProviderSelected = false;
        this.firstName = null; // C-095
        this.lastName = null; // C-095
        this.deaExpItemDate = null; //C-095.1
        this.stateLicenseExpItemDate = null; //C-095.1
        this.getStatus = null; //C-095.1
        // C-095
        this.checkIsPICexpired = async () => {
            var _a, _b;
            let picId = this.siteHasPic;
            await ((_b = (_a = store_4.sitesDetailStore === null || store_4.sitesDetailStore === void 0 ? void 0 : store_4.sitesDetailStore.providers) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.map((provider, i) => {
                if (provider.id == picId) {
                    const today = moment().format('YYYY-MM-DD');
                    let stateLicenseExpItem = moment(provider === null || provider === void 0 ? void 0 : provider.stateLicenseExp).format('YYYY-MM-DD');
                    let deaExpItem = moment(provider === null || provider === void 0 ? void 0 : provider.deaExp).format('YYYY-MM-DD');
                    //C-095.1
                    if (stateLicenseExpItem === "Invalid date") {
                        this.stateLicenseExpItemDate = "";
                    }
                    else {
                        if (moment(stateLicenseExpItem).isSameOrAfter(today) === false) {
                            this.stateLicenseExpItemDate = "State License";
                        }
                        else if (moment(stateLicenseExpItem).isSameOrAfter(today) === true) {
                            this.stateLicenseExpItemDate = "";
                        }
                    }
                    if (deaExpItem === "Invalid date") {
                        this.deaExpItemDate = "";
                    }
                    else {
                        if (moment(deaExpItem).isSameOrAfter(today) === false) {
                            this.deaExpItemDate = "DEA License";
                        }
                        else if (moment(deaExpItem).isSameOrAfter(today) === true) {
                            this.deaExpItemDate = "";
                        }
                    }
                    // C-095.1
                    if (this.stateLicenseExpItemDate.length && this.deaExpItemDate.length) {
                        this.getStatus = provider.firstName + "  " + provider.lastName + " - " + this.stateLicenseExpItemDate + " & " + this.deaExpItemDate + " Expired";
                    }
                    else if (this.stateLicenseExpItemDate.length) {
                        this.getStatus = provider.firstName + "  " + provider.lastName + " - " + this.stateLicenseExpItemDate + " Expired";
                    }
                    else if (this.deaExpItemDate.length) {
                        this.getStatus = provider.firstName + "  " + provider.lastName + " - " + this.deaExpItemDate + " Expired";
                    }
                    if (moment(stateLicenseExpItem).isSameOrAfter(today) && moment(deaExpItem).isSameOrAfter(today)) {
                        this.isPICExpired = false;
                    }
                    else {
                        this.isPICExpired = true;
                    }
                }
            }));
        };
        this.renderListRowEditMode = (submission, index) => {
            if (this.editRowIndex === index) {
                if (submission.status === order_1.SubmissionStatus.InvalidPatient ||
                    submission.status === order_1.SubmissionStatus.MissingPatient ||
                    submission.status === order_1.SubmissionStatus.NoRxCoverage) {
                    return (React.createElement(Table_1.TableRow, { key: -1 },
                        React.createElement(Table_1.TableCell, { colSpan: 6, className: "orders-submit__patient-info" },
                            React.createElement(edit_patient_1.EditPatient, { error: store_2.patientsStore.patient.error, warning: this.patient.missingInsurance, loading: store_2.patientsStore.patient.loading, onCancel: this.onCancelEditRow, onSave: this.onSaveEditPatient, onAfterE1: (patient) => this.onRefreshAfterUploadE1(patient, submission), patient: this.patient, submission: submission, status: store_2.patientsStore.patient.status, slim: true }))));
                }
                if (submission.status === order_1.SubmissionStatus.InvalidProvider ||
                    submission.status === order_1.SubmissionStatus.MissingProvider) {
                    return (React.createElement(Table_1.TableRow, { key: -1 },
                        React.createElement(Table_1.TableCell, { colSpan: 6, className: "provider-info" },
                            React.createElement(edit_provider_1.EditProvider, { error: store_3.providersStore.provider.error, key: index, loading: store_3.providersStore.provider.loading, onCancel: this.onCancelEditRow, onSave: this.onSaveEditProvider, provider: this.provider, status: store_3.providersStore.provider.status, newProvider: false, slim: true }))));
                }
                return null;
            }
            return null;
        };
        this.renderListRow = (submission, index) => {
            const duplicateOrderId = submission.refOrderId;
            const link = `/claims/${duplicateOrderId}`;
            let className = this.currentRowIndex === index ? "edit-active" : "edit-inactive";
            if (submission.id === this.highlightOrderId &&
                submission.status !== order_1.SubmissionStatus.DuplicateInList) {
                className += " ref";
            }
            if (submission.status === order_1.SubmissionStatus.DuplicateInList &&
                this.showDuplicatesForOrderId !== submission.refOrderId) {
                return null;
            }
            let { status } = submission;
            if (status === order_1.SubmissionStatus.DuplicateInList) {
                className += " duplicate";
                const parentSubmission = store_1.ordersStore.submission.value &&
                    store_1.ordersStore.submission.value.find(s => submission.refOrderId === s.id);
                if (parentSubmission) {
                    status = parentSubmission.status;
                }
            }
            let statusText = "";
            switch (status) {
                case order_1.SubmissionStatus.Valid:
                    statusText = "Ready To Transmit";
                    break;
                case order_1.SubmissionStatus.Invalid:
                    statusText = "Invalid Data";
                    break;
                case order_1.SubmissionStatus.InvalidPatient:
                    statusText = "Invalid Patient";
                    break;
                case order_1.SubmissionStatus.InvalidPIC:
                    statusText = "Invalid Physician in Charge";
                    break;
                case order_1.SubmissionStatus.InvalidProvider:
                    statusText = "Invalid Provider";
                    break;
                case order_1.SubmissionStatus.MissingPatient:
                    statusText = "Patient Not Found";
                    break;
                case order_1.SubmissionStatus.MissingProvider:
                    statusText = "Provider Not Found";
                    break;
                case order_1.SubmissionStatus.Duplicate:
                    statusText = "Already Submitted";
                    break;
                case order_1.SubmissionStatus.NoRxCoverage:
                    statusText = "No Rx Coverage";
                    break;
                case order_1.SubmissionStatus.NoInsurance:
                    statusText = "No Insurance";
                    break;
                default:
                    break;
            }
            if (submission.status !== order_1.SubmissionStatus.Valid &&
                submission.status !== order_1.SubmissionStatus.Invalid &&
                submission.status !== order_1.SubmissionStatus.InvalidPIC &&
                submission.status !== order_1.SubmissionStatus.Duplicate &&
                submission.status !== order_1.SubmissionStatus.DuplicateInList) {
                className += " selectable";
            }
            return [
                React.createElement(Table_1.TableRow, { key: index, onClick: () => {
                        if (submission.status !== order_1.SubmissionStatus.DuplicateInList &&
                            submission.status !== order_1.SubmissionStatus.Duplicate &&
                            !this.loadingSaving) {
                            this.handleRowClick(submission, index);
                        }
                    }, className: className, onMouseEnter: () => this.onHoverDuplicate(submission), onMouseLeave: () => this.onHoverDuplicate() },
                    React.createElement(Table_1.TableCell, null, submission.status !== order_1.SubmissionStatus.DuplicateInList && (React.createElement(checkbox_1.MaterialCheckbox, { onAction: () => this.handleCheckRow(submission), label: "", checked: this.checkedBoxes[submission.id] || false, disabled: submission.status !== order_1.SubmissionStatus.Valid }))),
                    React.createElement(Table_1.TableCell, null,
                        submission.patient.firstName,
                        " ",
                        submission.patient.lastName),
                    React.createElement(Table_1.TableCell, null,
                        React.createElement("div", { className: "orders-submit__row" },
                            moment(submission.date, "YYYYMMDD").format("M/D/YY"),
                            " ",
                            submission.time,
                            moment(`${submission.date} ${submission.time}`, "YYYYMMDD h:mm A").isBefore(moment()) && (React.createElement(Warning_1.default, { className: "warning", "data-tip": "This appointment time has already passed", "data-place": "right" })))),
                    React.createElement(Table_1.TableCell, null,
                        submission.provider && submission.provider.prefix
                            ? submission.provider.prefix
                            : "",
                        submission.provider && submission.provider.prefix ? " " : "",
                        submission.provider ? submission.provider.firstName : "",
                        " ",
                        submission.provider ? submission.provider.lastName : "",
                        submission.provider && submission.provider.suffix
                            ? submission.provider.suffix
                            : ""),
                    React.createElement(Table_1.TableCell, { "data-tip": submission.message },
                        React.createElement("div", { className: "orders-submit__row" },
                            React.createElement("div", { className: `orders-submit__status orders-submit__status--${status}` }),
                            " ",
                            React.createElement("div", { className: "orders-submit__status-text" }, statusText),
                            submission.status === order_1.SubmissionStatus.Duplicate &&
                                submission.refOrderId && (React.createElement("a", { href: link, target: "_blank", className: "view" },
                                React.createElement(Launch_1.default, null),
                                " view")),
                            submission.duplicates && (React.createElement("a", { className: "duplicates", onClick: (e) => this.onShowDuplicates(e, submission.id) },
                                "+",
                                submission.duplicates,
                                " duplicate",
                                submission.duplicates > 1 ? "s" : ""))))),
                this.renderListRowEditMode(submission, index)
            ];
        };
        this.renderKPIElement = (element) => {
            let value;
            switch (element.color) {
                case "green":
                    value = this.readyCount;
                    break;
                case "red":
                    value = this.actionRequiredCount;
                    break;
                case "yellow":
                    value = this.duplicateCount;
                    break;
                default:
                    value = 0;
            }
            const newElement = ramda_1.merge(element, { value });
            return React.createElement(kpi_element_1.KpiElement, { element: newElement });
        };
        this.onClickCancelUploadRestart = () => {
            this.cancelButtonClicked = false;
            store_1.ordersStore.setSubmissionInProgress(false);
        };
        this.onClickConfirmUploadRestart = async () => {
            this.cancelButtonClicked = false;
            store_1.ordersStore.reset();
            this.resetSite();
        };
        this.renderModal = () => (this.cancelButtonClicked || store_1.ordersStore.submissionInProgress) && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Confirm and continue", cancelText: "Cancel and go back", message: "You already have a submission in progress.<br/><strong>You will lose all progress made so far.</strong>", onCancel: this.onClickCancelUploadRestart, onConfirm: this.onClickConfirmUploadRestart, title: "Are you sure you want to proceed?" }));
        this.handleLoadProviders = async (id) => {
            await store_4.sitesDetailStore.loadProviders({
                count: 100,
                id: Number(id),
                start: 0
            });
            await store_4.sitesDetailStore.readSite(Number(id));
        };
        this.handleChangeSite = async (id) => {
            this.siteId = id;
            store_1.ordersStore.selectedSiteId = id;
            this.providerId = null;
            this.provider = null;
            store_1.ordersStore.selectedProviderId = null;
            this.handleLoadProviders(id);
        };
        this.handleChangeProvider = async (id) => {
            const providerId = Number(id);
            if (id !== null) {
                this.providerId = id;
                this.provider = (await store_3.providersStore.readProvider(providerId));
                store_1.ordersStore.selectedProviderId = this.providerId;
            }
            else {
                this.providerId = null;
                this.provider = null;
                store_1.ordersStore.selectedProviderId = null;
            }
        };
        this.handleClickCancel = () => {
            this.cancelButtonClicked = true;
            // reset selected site id
            this.selectedSiteId = null;
        };
        this.handleClickUploadMore = () => {
            store_1.ordersStore.reset();
            this.resetSite();
        };
        // Will probably need to persist Site Id in store as well.
        // Site Selected and submission in progress will determine if to render the dropdown selection
        // or to render the drag and drop component.
        // Need to persist the store so that the user can see validation errors
        this.handleClickNext = async () => {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            // C-095.3
            let arr = ['MD', 'DO', 'APRN', 'DPM'];
            if (!arr.includes((_a = this.provider) === null || _a === void 0 ? void 0 : _a.title)) {
                this.checkIsPICexpired(); // C-095
            }
            this.firstName = (_b = this.provider.firstName) !== null && _b !== void 0 ? _b : ""; // C-095.1
            this.lastName = (_c = this.provider.lastName) !== null && _c !== void 0 ? _c : ""; // C-095.1
            const pFirstName = (_d = this.provider.firstName) !== null && _d !== void 0 ? _d : "";
            const pLastName = (_e = this.provider.lastName) !== null && _e !== void 0 ? _e : "";
            const pPrefix = (_f = this.provider.prefix) !== null && _f !== void 0 ? _f : "";
            const pSuffix = (_g = this.provider.suffix) !== null && _g !== void 0 ? _g : "";
            const pTitle = (_h = this.provider.title) !== null && _h !== void 0 ? _h : "";
            const provider = `${pPrefix} ${pFirstName} ${pLastName} ${pSuffix}${pTitle ? `, ${pTitle}` : pTitle}`;
            const siteStore = store_4.sitesDetailStore;
            const thisSite = siteStore.site.value;
            const siteName = thisSite.name;
            store_1.ordersStore.setSubmissionInProgress(false);
            store_1.ordersStore.setSiteSelected(true);
            this.siteSelected = store_1.ordersStore.siteSelected;
            this.providerId = store_1.ordersStore.selectedProviderId;
            this.siteAndProviderSelected = !!this.siteSelected && !!this.providerId;
            const logData = {
                action: `Started schedule upload for ${siteName} under ${provider}.`,
                category: store_6.LogCategory.schedule,
                site: thisSite.id,
                user: store_6.usersStore.user.value.id
            };
            await store_6.usersStore.createLog(logData);
        };
        this.handleClickSubmit = async () => {
            const submission = store_1.ordersStore.submission.value;
            const invalidSubmissions = submission === null || submission === void 0 ? void 0 : submission.filter((row) => row.status !== order_1.SubmissionStatus.Duplicate &&
                row.status !== order_1.SubmissionStatus.DuplicateInList &&
                row.status !== order_1.SubmissionStatus.Valid);
            // Need to filter out invalidpatients to omit duplicates.
            const seenSubmissions = [];
            const invalidSubmissionsNoDuplicate = [];
            invalidSubmissions === null || invalidSubmissions === void 0 ? void 0 : invalidSubmissions.forEach((row) => {
                const patientFirstNameNormalized = row.patient.firstName
                    ? row.patient.firstName.toLowerCase().trim()
                    : "";
                const patientLastNameNormalized = row.patient.firstName
                    ? row.patient.firstName.toLowerCase().trim()
                    : "";
                const patientDateIdentifier = `${row.date}_${patientFirstNameNormalized}_${patientLastNameNormalized}`;
                if (!seenSubmissions.includes(patientDateIdentifier)) {
                    seenSubmissions.push(patientDateIdentifier);
                    invalidSubmissionsNoDuplicate.push(row);
                }
            });
            const seenPatients = [];
            const validPatients = submission === null || submission === void 0 ? void 0 : submission.filter((row) => row.status === order_1.SubmissionStatus.Valid);
            validPatients === null || validPatients === void 0 ? void 0 : validPatients.forEach((row) => {
                const patientDateIdentifier = `${row.date}_${row.patient.id}`;
                if (!seenPatients.includes(patientDateIdentifier)) {
                    seenPatients.push(patientDateIdentifier);
                }
                else {
                    this.checkedBoxes[row.id] = false;
                }
            });
            const siteId = String(store_1.ordersStore.importedFileAndSiteId.siteId) || this.siteId;
            await store_1.ordersStore.submit(siteId, this.checkedBoxes);
            await store_1.ordersStore.addQueue(Number(siteId), invalidSubmissionsNoDuplicate);
            const logData = {
                action: `Submitted ${invalidSubmissionsNoDuplicate.length} to queue, ${this.numChecked} to pending.`,
                category: store_6.LogCategory.schedule,
                site: Number(siteId),
                user: store_6.usersStore.user.value.id
            };
            await store_6.usersStore.createLog(logData);
        };
        this.handleDrop = async (accepted) => {
            if (accepted.length) {
                await store_1.ordersStore.parseImportsHeader(accepted, this.siteId);
                this.imageFiles = accepted;
                store_1.ordersStore.importedFileAndSiteId = {
                    accepted,
                    siteId: this.siteId
                };
                const logData = {
                    action: `Uploaded file to schedule: "${accepted[0].name}" | Size: ${accepted[0].size} b | Modified: ${moment(accepted[0].lastModified).format("YYYY-MM-DD hh:mm:s A")}.`,
                    category: store_6.LogCategory.schedule,
                    site: Number(this.siteId),
                    user: store_6.usersStore.user.value.id
                };
                await store_6.usersStore.createLog(logData);
                router_1.RouteManager.transitionTo("/claims/submit/select");
            }
        };
        this.renderImportSubmissions = async () => {
            const { accepted } = store_1.ordersStore.importedFileAndSiteId;
            if (accepted.length) {
                // await ordersStore.parse(accepted, this.siteId);
                this.imageFiles = accepted;
                this.checkedAll = true;
                store_1.ordersStore.validSubmissions
                    .filter(submission => submission.status === order_1.SubmissionStatus.Valid)
                    .map(submission => {
                    this.checkedBoxes[submission.id] = true;
                    this.checkedBoxes = ramda_1.merge(this.checkedBoxes, {
                        [submission.id]: true
                    });
                });
                this.updateNumChecked();
                this.editRowIndex = -1;
                this.currentRowIndex = -1;
            }
            store_1.ordersStore.setSubmissionInProgress(false);
        };
        this.handleRowClick = async (submission, index) => {
            this.cacheRowIndex = index;
            this.showDuplicatesForOrderId = undefined;
            if (this.editRowIndex === index) {
                this.editRowIndex = -1;
            }
            else {
                this.editRowIndex = index;
                this.currentRowIndex = index;
                if (submission.patient.id) {
                    const patient = await store_2.patientsStore.readPatientSubmission(submission.patient);
                    if (patient) {
                        this.patient = patient;
                    }
                }
                else {
                    await store_2.patientsStore.readNewPatient(submission.patient);
                    this.patient = ramda_1.merge(submission.patient, {});
                }
                if (submission.provider && submission.id) {
                    const provider = await store_3.providersStore.readProviderSubmission(submission.provider);
                    if (provider) {
                        this.provider = provider;
                    }
                }
                else {
                    await store_3.providersStore.readNewProvider(submission.provider);
                    this.provider = ramda_1.merge(submission.provider, {});
                }
            }
        };
        this.onCancelEditRow = () => {
            this.editRowIndex = -1;
        };
        this.updateNumChecked = () => {
            let numChecked = 0;
            for (const key in this.checkedBoxes) {
                if (this.checkedBoxes[key]) {
                    numChecked++;
                }
            }
            this.numChecked = numChecked;
            if (this.numChecked === 0) {
                this.checkedAll = false;
                this.indeterminate = false;
            }
            else if (this.numChecked === store_1.ordersStore.validSubmissions.length) {
                this.checkedAll = true;
                this.indeterminate = false;
            }
            else {
                this.indeterminate = true;
            }
        };
        this.handleCheckAll = () => {
            if (this.checkedAll) {
                this.checkedBoxes = {};
            }
            else {
                store_1.ordersStore.validSubmissions
                    .filter(submission => submission.status === order_1.SubmissionStatus.Valid)
                    .map(submission => {
                    this.checkedBoxes = ramda_1.merge(this.checkedBoxes, {
                        [submission.id]: true
                    });
                });
            }
            this.checkedAll = !this.checkedAll;
            this.updateNumChecked();
        };
        this.handleCheckRow = (submission) => {
            this.checkedBoxes = ramda_1.merge(this.checkedBoxes, {
                [submission.id]: !this.checkedBoxes[submission.id]
            });
            this.updateNumChecked();
        };
        this.onHoverDuplicate = (submission) => {
            if (submission) {
                this.highlightOrderId = submission.refOrderId;
            }
            else {
                this.highlightOrderId = undefined;
            }
        };
        this.onSaveEditPatient = async (patient, insurance, submission) => {
            this.editRowIndex = -1;
            let result;
            this.patient = patient;
            // B-059
            this.providerId = store_1.ordersStore.selectedProviderId;
            this.siteAndProviderSelected = !!this.siteSelected && !!this.providerId;
            if (patient.id) {
                result = await store_2.patientsStore.savePatient(patient, insurance);
            }
            else {
                result = await store_2.patientsStore.createPatient(patient);
            }
            if (result) {
                const updatedPatient = await store_2.patientsStore.readPatient(result.id);
                if (updatedPatient) {
                    this.patient = updatedPatient;
                }
            }
            // @tkay Only build a patient schedule if a patient has just been created, in which case, run an E1
            const isNewPatient = !patient.id; // check whether updated a patient or created a new one.
            if (store_1.ordersStore.patientSchedulesAndSite) {
                this.loadingSaving = true;
                const { patientSchedules, siteId } = store_1.ordersStore.patientSchedulesAndSite;
                result &&
                    (await store_1.ordersStore.parseMappedSchedule(patientSchedules, siteId, submission, isNewPatient, this.providerId));
                this.loadingSaving = false;
            }
        };
        this.onRefreshAfterUploadE1 = async (patient, submission) => {
            this.patient = patient;
            if (!store_1.ordersStore.patientSchedulesAndSite) {
                return;
            }
            this.providerId = store_1.ordersStore.selectedProviderId;
            const { patientSchedules, siteId } = store_1.ordersStore.patientSchedulesAndSite;
            await store_1.ordersStore.parseMappedSchedule(patientSchedules, siteId, submission, false, this.providerId, true);
        };
        this.onSaveEditProvider = async (provider) => {
            let result;
            this.provider = provider;
            if (provider.id) {
                result = await store_3.providersStore.saveProvider(provider);
            }
            else {
                result = await store_3.providersStore.createProvider(provider);
            }
            // @tkay added
            if (store_1.ordersStore.patientSchedulesAndSite) {
                const { patientSchedules, siteId } = store_1.ordersStore.patientSchedulesAndSite;
                result &&
                    (await store_1.ordersStore.parseMappedSchedule(patientSchedules, siteId, null, null, this.providerId));
            }
            // result && (await this.handleDrop(this.imageFiles));
            this.editRowIndex = this.cacheRowIndex;
        };
        this.onShowDuplicates = async (e, id) => {
            e.preventDefault();
            e.stopPropagation();
            if (this.showDuplicatesForOrderId === id) {
                this.showDuplicatesForOrderId = undefined;
            }
            else {
                this.showDuplicatesForOrderId = id;
            }
            this.editRowIndex = -1;
            this.cacheRowIndex = -1;
            this.currentRowIndex = -1;
        };
        // this.handleClickUploadMore(); // @tkay added
    }
    get availableOptions() {
        return store_5.sitesListStore.sites.value
            ? store_5.sitesListStore.sites.value.map((site, i) => ({
                id: i,
                label: site.displayName || site.name,
                value: site.id.toString()
            }))
            : [];
    }
    get siteHasPic() {
        const selectedSite = store_5.sitesListStore.sites.value.find(site => site.id === Number(this.siteId));
        return selectedSite === null || selectedSite === void 0 ? void 0 : selectedSite.picProviderId;
    }
    get availableProviders() {
        return store_4.sitesDetailStore.providers.value
            ? store_4.sitesDetailStore.providers.value
                .filter(provider => {
                const isUnavailable = provider.sitesAbsent.find(site => String(site.id) === String(this.siteId));
                return !isUnavailable;
            })
                .map((provider, i) => {
                const today = moment().startOf("day");
                const isExpired = moment(today).isSameOrAfter(provider.deaExp) ||
                    moment(today).isSameOrAfter(provider.stateLicenseExp);
                if (isExpired) {
                    return {
                        disabled: true,
                        id: i,
                        label: `${provider.prefix} ${provider.firstName} ${provider.lastName} ${provider.suffix} (DEA/License Expired)`,
                        value: provider.id.toString()
                    };
                }
                return {
                    id: i,
                    label: `${provider.prefix} ${provider.firstName} ${provider.lastName} ${provider.suffix}`,
                    value: provider.id.toString()
                };
            })
            : [];
    }
    get actionRequiredCount() {
        const submissions = store_1.ordersStore.submission.value;
        const statuses = [
            order_1.SubmissionStatus.Invalid,
            order_1.SubmissionStatus.InvalidPatient,
            order_1.SubmissionStatus.InvalidPIC,
            order_1.SubmissionStatus.InvalidProvider,
            order_1.SubmissionStatus.MissingPatient,
            order_1.SubmissionStatus.MissingProvider,
            order_1.SubmissionStatus.NoInsurance
        ];
        return submissions
            ? statuses.reduce((a, c) => a +
                submissions.filter(submission => submission.status === c).length, 0)
            : 0;
    }
    get readyCount() {
        const submissions = store_1.ordersStore.submission.value;
        return submissions
            ? submissions.filter(submission => submission.status === order_1.SubmissionStatus.Valid).length
            : 0;
    }
    get duplicateCount() {
        const submissions = store_1.ordersStore.submission.value;
        return submissions
            ? submissions.filter(submission => submission.status === order_1.SubmissionStatus.Duplicate).length
            : 0;
    }
    getSiteName(siteId) {
        const site = store_5.sitesListStore.sites.value &&
            store_5.sitesListStore.sites.value.find(site => siteId === String(site.id));
        const siteName = site ? site.displayName || site.name : "";
        return siteName;
    }
    componentWillMount() {
        store_1.ordersStore.selectedSiteId = this.siteId;
        // sitesListStore.loadSites();
        store_5.sitesListStore.loadSitesNoRelation();
        this.resetSite();
        this.siteSelected = store_1.ordersStore.siteSelected;
        if (!this.providerId)
            this.handleLoadProviders(this.siteId);
    }
    componentWillUnmount() {
        store_1.ordersStore.reset();
        this.resetSite();
    }
    componentDidMount() {
        if (store_1.ordersStore.importedFileAndSiteId &&
            store_1.ordersStore.importedFileAndSiteId.accepted) {
            this.renderImportSubmissions();
        }
    }
    componentDidUpdate() {
        ReactTooltip.rebuild();
    }
    resetSite() {
        if (store_6.usersStore.user.value && store_6.usersStore.user.value.siteUser) {
            store_1.ordersStore.setSiteSelected(true);
        }
        else {
            store_1.ordersStore.setSiteSelected(false);
        }
        this.checkedBoxes = {};
        this.showDuplicatesForOrderId = undefined;
        this.highlightOrderId = undefined;
    }
    render() {
        const loadingClass = this.loadingSaving
            ? " ui-dropzone__loading-bg--loading"
            : "";
        const { submission: { loading, value } } = store_1.ordersStore;
        const disabled = !this.providerId;
        const siteStore = store_4.sitesDetailStore;
        const thisSite = siteStore.site.value;
        const pharmLink = thisSite && `/pharmacies/${thisSite.id}`;
        const PatientID = siteStore.totalPatientCount; //E-025
        const patientLink = thisSite && `/pharmacies/${thisSite.id}/patients`; //E-025
        const invalidSubmissions = value === null || value === void 0 ? void 0 : value.filter((row) => row.status !== order_1.SubmissionStatus.Duplicate &&
            row.status !== order_1.SubmissionStatus.DuplicateInList &&
            row.status !== order_1.SubmissionStatus.Valid
        // row.status === SubmissionStatus.InvalidPatient ||
        // row.status === SubmissionStatus.MissingPatient ||
        // row.status === SubmissionStatus.NoRxCoverage ||
        // row.status === SubmissionStatus.NoInsurance
        );
        const seenSubmissions = [];
        const invalidSubmissionsNoDuplicate = [];
        invalidSubmissions === null || invalidSubmissions === void 0 ? void 0 : invalidSubmissions.forEach((row) => {
            const patientFirstNameNormalized = row.patient.firstName
                ? row.patient.firstName.toLowerCase().trim()
                : "";
            const patientLastNameNormalized = row.patient.firstName
                ? row.patient.firstName.toLowerCase().trim()
                : "";
            const patientDateIdentifier = `${row.date}_${patientFirstNameNormalized}_${patientLastNameNormalized}`;
            if (!seenSubmissions.includes(patientDateIdentifier)) {
                seenSubmissions.push(patientDateIdentifier);
                invalidSubmissionsNoDuplicate.push(row);
            }
        });
        const numQueue = invalidSubmissionsNoDuplicate.length;
        const hasPIC = thisSite === null || thisSite === void 0 ? void 0 : thisSite.picProviderId;
        // TMPP > Claims > Upload Schedule Inability E-025
        //   New warning message for missing patient
        const patientAssocited = PatientID && PatientID.length > 0; //E-025
        // const warnPatientMissing = (
        //   <p style={{ marginTop: 0 }}>
        //     Pharmacy must have a minimum of one patient.
        //     <br />
        //     <span>
        //       <a
        //         style={{color: 'blue'}}
        //         onClick={() => RouteManager.transitionTo(patientLink)}
        //       >
        //         Click here
        //       </a>{" "}
        //       to add a patient to the pharmacy.
        //     </span>
        //   </p>
        // );
        const warning = (React.createElement("p", { style: { marginTop: 0 } },
            "Pharmacies ",
            React.createElement("b", null, "must"),
            " have a provider in charge.",
            React.createElement("br", null),
            store_6.usersStore.permissions.UpdatePharmacy && (React.createElement("span", null,
                React.createElement("a", { className: "pharmLink", onClick: () => router_1.RouteManager.transitionTo(pharmLink) }, "Click here"),
                " ",
                "to modify the pharmacy's settings."))));
        const isTmp = store_6.usersStore.user.value.user;
        return (React.createElement("div", { className: "orders-submit" }, store_6.usersStore.permissions.CreateClaims ? (React.createElement(React.Fragment, null,
            React.createElement(kpi_header_1.KpiHeader, { center: false, noDivider: true },
                React.createElement(kpi_title_1.KpiTitle, { label: "Upload Patient Schedule", subLabel: this.getSiteName(String(store_1.ordersStore.importedFileAndSiteId &&
                        store_1.ordersStore.importedFileAndSiteId.siteId) || this.siteId) }),
                value && value.length > 0 && this.renderKPIElementGroup()),
            this.loadingSaving && (React.createElement("div", { className: `orders-submit-preview__header-preview__loading-bg${loadingClass}` },
                React.createElement(loading_indicator_1.UiLoadingIndicator, { className: "orders-submit-preview__header-preview__loading-indicator" }))),
            this.cancelButtonClicked && this.renderModal(),
            !this.cancelButtonClicked &&
                !store_1.ordersStore.submitted &&
                (!store_1.ordersStore.submission.value ||
                    store_1.ordersStore.submission.value.length === 0) && (React.createElement(paper_1.MaterialPaper, { className: "orders-submit__submission" },
                store_1.ordersStore.submission.error && (React.createElement(alert_1.UiAlert, { title: "Error", type: "error", message: store_1.ordersStore.submission.error })),
                store_1.ordersStore.submission.value &&
                    store_1.ordersStore.submission.value.length === 0 && (React.createElement(alert_1.UiAlert, { title: "Error", type: "error", message: "No appointments found in the uploaded file" })),
                !this.siteAndProviderSelected && (React.createElement("form", { className: "orders-submit__site-form" },
                    React.createElement("p", null,
                        React.createElement("strong", null, isTmp
                            ? `Please Select a Pharmacy and Provider Before Submission`
                            : `Please Select a Provider Before Submission`)),
                    isTmp ? (React.createElement(select_1.MaterialSelect, { className: "orders-submit__site-select", label: "Pharmacy", options: this.availableOptions, value: this.siteId || "Choose pharmacy...", onSelect: this.handleChangeSite, onInputChange: e => {
                            util_1.pharmacyDropDownHandler({
                                id: Number(this.siteId),
                                search: e
                            });
                        }, searchable: true })) : null,
                    !hasPIC ? warning : patientAssocited === 0 ? (React.createElement("p", { style: { marginTop: 0 } },
                        "Pharmacy must have a minimum of one patient.",
                        React.createElement("br", null),
                        React.createElement("span", null,
                            React.createElement("a", { 
                                // className="patientLink"
                                style: { color: 'blue' }, onClick: () => router_1.RouteManager.transitionTo(patientLink) }, "Click here"),
                            " ",
                            "to add a patient to the pharmacy."))) : null,
                    React.createElement(select_1.MaterialSelect, { className: "orders-submit__site-select", disabled: !hasPIC || patientAssocited === 0, options: this.availableProviders, required: true, searchable: true, label: "Provider", onSelect: this.handleChangeProvider, value: String(this.providerId) || "No Providers Found" }),
                    React.createElement(button_1.MaterialButton, { className: "orders-submit__site-button", primary: true, disabled: disabled || !hasPIC, onClick: this.handleClickNext }, "Next"))),
                React.createElement(ui_1.UiDropzone, { disabled: !hasPIC, className: "orders-submit__dropzone", onDrop: this.handleDrop, loading: store_1.ordersStore.submission.loading }, hasPIC ? (React.createElement(React.Fragment, null,
                    React.createElement(Backup_1.default, { className: "orders-submit__download-icon" }),
                    React.createElement("p", null,
                        React.createElement("strong", null, "Drag & Drop Patient Schedule"),
                        React.createElement("br", null),
                        React.createElement("small", null, "(.rtf, .xlsx, .xls, .csv, or .txt only)")),
                    React.createElement("div", { className: "order-submit__dropzone-button" },
                        React.createElement(button_1.MaterialButton, { flat: true, className: "browse-button" }, "Browse to Upload")))) : (warning)))),
            !store_1.ordersStore.submitted &&
                store_1.ordersStore.submission.value &&
                store_1.ordersStore.submission.value.length > 0 && (React.createElement("div", null,
                React.createElement(paper_1.MaterialPaper, { noPadding: true },
                    React.createElement(Table_1.default, null,
                        React.createElement(Table_1.TableHead, null,
                            React.createElement(Table_1.TableRow, null,
                                React.createElement(Table_1.TableCell, { "data-tip": "Select All", "data-place": "right" },
                                    React.createElement(checkbox_1.MaterialCheckbox, { onAction: this.handleCheckAll, label: "", checked: this.checkedAll, indeterminate: this.indeterminate })),
                                React.createElement(Table_1.TableCell, null, "Patient Name"),
                                React.createElement(Table_1.TableCell, null, "Appt Time"),
                                React.createElement(Table_1.TableCell, null, "Provider"),
                                React.createElement(Table_1.TableCell, null, "Status"))),
                        React.createElement(Table_1.TableBody, null, store_1.ordersStore.submission.value.map((submission, index) => this.renderListRow(submission, index))))),
                this.renderModal(),
                React.createElement("div", { className: "orders-submit__footer" },
                    React.createElement(toolbar_1.MaterialToolBar, null,
                        React.createElement(button_1.MaterialButton, { disabled: loading, onClick: this.handleClickUploadMore }, "Upload more"),
                        React.createElement(button_1.MaterialButton, { disabled: loading, onClick: this.handleClickCancel }, "Cancel"),
                        React.createElement(button_1.MaterialButton, { disabled: loading, primary: true, onClick: this.handleClickSubmit },
                            "Submit ",
                            this.numChecked,
                            " | Queue ",
                            numQueue))))),
            store_1.ordersStore.submitted &&
                ((store_1.ordersStore.submissionInProgress &&
                    this.handleClickUploadMore) || (React.createElement(paper_1.MaterialPaper, null,
                    React.createElement("div", { className: "orders-submit__dropzone" },
                        React.createElement(CheckCircle_1.default, { className: "orders-submit__download-icon" }),
                        React.createElement("p", null,
                            React.createElement("strong", null, "Success!"),
                            React.createElement("br", null),
                            React.createElement("small", null, "Your submission has been transmitted."),
                            React.createElement("br", null),
                            React.createElement("small", null, "Visit the Claims page for the latest updates.")),
                        React.createElement("div", { className: "orders-submit__row" },
                            React.createElement(button_1.MaterialButton, { primary: true, to: "/claims" }, "Go to Claims"),
                            React.createElement(button_1.MaterialButton, { secondary: true, onClick: this.handleClickUploadMore }, "Upload More")))))),
            React.createElement(ReactTooltip, { className: "tooltip", effect: "solid", place: "left", multiline: true }))) : (store_6.usersStore.showLock())));
    }
    renderKPIElementGroup() {
        return (React.createElement(kpi_element_group_1.KpiElementGroup, { greenElement: greenElement, redElement: redElement, yellowElement: yellowElement, renderElement: this.renderKPIElement.bind(this) }));
    }
};
__decorate([
    mobx_1.computed
], OrdersSubmit.prototype, "availableOptions", null);
__decorate([
    mobx_1.computed
], OrdersSubmit.prototype, "siteHasPic", null);
__decorate([
    mobx_1.computed
], OrdersSubmit.prototype, "availableProviders", null);
__decorate([
    mobx_1.computed
], OrdersSubmit.prototype, "actionRequiredCount", null);
__decorate([
    mobx_1.computed
], OrdersSubmit.prototype, "readyCount", null);
__decorate([
    mobx_1.computed
], OrdersSubmit.prototype, "duplicateCount", null);
__decorate([
    mobx_1.observable
], OrdersSubmit.prototype, "checkedBoxes", void 0);
__decorate([
    mobx_1.observable
], OrdersSubmit.prototype, "checkedAll", void 0);
__decorate([
    mobx_1.observable
], OrdersSubmit.prototype, "indeterminate", void 0);
__decorate([
    mobx_1.observable
], OrdersSubmit.prototype, "numChecked", void 0);
__decorate([
    mobx_1.observable
], OrdersSubmit.prototype, "editRowIndex", void 0);
__decorate([
    mobx_1.observable
], OrdersSubmit.prototype, "currentRowIndex", void 0);
__decorate([
    mobx_1.observable
], OrdersSubmit.prototype, "patient", void 0);
__decorate([
    mobx_1.observable
], OrdersSubmit.prototype, "provider", void 0);
__decorate([
    mobx_1.observable
], OrdersSubmit.prototype, "siteId", void 0);
__decorate([
    mobx_1.observable
], OrdersSubmit.prototype, "siteSelected", void 0);
__decorate([
    mobx_1.observable
], OrdersSubmit.prototype, "imageFiles", void 0);
__decorate([
    mobx_1.observable
], OrdersSubmit.prototype, "highlightOrderId", void 0);
__decorate([
    mobx_1.observable
], OrdersSubmit.prototype, "showDuplicatesForOrderId", void 0);
__decorate([
    mobx_1.observable
], OrdersSubmit.prototype, "cancelButtonClicked", void 0);
__decorate([
    mobx_1.observable
], OrdersSubmit.prototype, "selectedSiteId", void 0);
__decorate([
    mobx_1.observable
], OrdersSubmit.prototype, "providerId", void 0);
__decorate([
    mobx_1.observable
], OrdersSubmit.prototype, "loadingSaving", void 0);
__decorate([
    mobx_1.observable
], OrdersSubmit.prototype, "isPICExpired", void 0);
__decorate([
    mobx_1.observable
], OrdersSubmit.prototype, "tkAccepted", void 0);
__decorate([
    mobx_1.observable
], OrdersSubmit.prototype, "siteAndProviderSelected", void 0);
__decorate([
    mobx_1.observable
], OrdersSubmit.prototype, "firstName", void 0);
__decorate([
    mobx_1.observable
], OrdersSubmit.prototype, "lastName", void 0);
__decorate([
    mobx_1.observable
], OrdersSubmit.prototype, "deaExpItemDate", void 0);
__decorate([
    mobx_1.observable
], OrdersSubmit.prototype, "stateLicenseExpItemDate", void 0);
__decorate([
    mobx_1.observable
], OrdersSubmit.prototype, "getStatus", void 0);
OrdersSubmit = __decorate([
    mobx_react_1.observer
], OrdersSubmit);
exports.OrdersSubmit = OrdersSubmit;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/orders/modules/orders-submit/orders-submit.tsx
// module id = 3771
// module chunks = 0